import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'
import type { Nil } from '@pbt/pbt-ui-components'

import DialogNames from '~/constants/DialogNames'
import useDialog from '~/utils/useDialog'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './SystemMessageAlert.module.scss'

const SystemMessageAlert = ({
  clientId,
  patientId,
}: {
  clientId: string | Nil
  patientId: string | Nil
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation(['Communications'])
  const [openNewConversationDialog] = useDialog(
    DialogNames.NEW_CONVERSATION_WITH_STEPS,
  )

  const handleNewMessage = () => {
    if (patientId) {
      navigate(`/patient/${patientId}`)
    } else if (clientId) {
      navigate(`/client/${clientId}`)
    } else {
      navigate('/communications')
    }

    openNewConversationDialog({ clientId, patientId })
  }

  return (
    <KibTopLevelAlert
      actions={
        <KibButtonNew
          emphasis="primary"
          size="small"
          theme="utility"
          onClick={handleNewMessage}
        >
          {t('Communications:MESSAGE_FORMATTING_AREA.NEW_MESSAGE')}
        </KibButtonNew>
      }
      className={styles.alert}
      heading={t(
        'Communications:MESSAGE_FORMATTING_AREA.SYSTEM_MESSAGE_ALERT_HEADING',
      )}
    />
  )
}

export default SystemMessageAlert
